/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpInCircleEmpty: {
  name: 'arrow-up-in-circle-empty';
  data: string;
} = {
  name: 'arrow-up-in-circle-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm.5 5.707V11a.5.5 0 0 1-1 0V6.207L6.354 7.354a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.207Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
